<template>
  <div class="task-stats">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="title">任务统计看板</span>
        <el-button style="float: right; padding: 3px 10px" type="text" @click="loadStats">
          <i class="el-icon-refresh"></i> 刷新
        </el-button>
      </div>
      
      <el-row :gutter="20" class="summary-row">
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-value">{{ stats.summary.totalTasks }}</div>
            <div class="stat-label">任务总数</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card success">
            <div class="stat-value">{{ stats.summary.totalCompleted }}</div>
            <div class="stat-label">已完成</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card warning">
            <div class="stat-value">{{ stats.summary.totalBySource }}</div>
            <div class="stat-label">来源统计</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card info">
            <div class="stat-value">{{ stats.summary.totalByCompleter }}</div>
            <div class="stat-label">完成人数</div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-card class="chart-card">
            <div slot="header">按任务类型</div>
            <el-table :data="stats.byType" style="width: 100%">
              <el-table-column prop="label" label="类型" width="120"></el-table-column>
              <el-table-column prop="count" label="数量"></el-table-column>
              <el-table-column prop="completed" label="已完成"></el-table-column>
              <el-table-column label="完成率">
                <template #default="scope">
                  {{ scope.row.count > 0 ? ((scope.row.completed / scope.row.count) * 100).toFixed(1) + '%' : '0%' }}
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>

        <el-col :span="12">
          <el-card class="chart-card">
            <div slot="header">按任务来源</div>
            <el-table :data="stats.bySource" style="width: 100%">
              <el-table-column prop="label" label="来源" width="120"></el-table-column>
              <el-table-column prop="count" label="数量"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="24">
          <el-card class="chart-card">
            <div slot="header">按完成者角色</div>
            <el-table :data="stats.byCompleter" style="width: 100%">
              <el-table-column prop="label" label="角色" width="150"></el-table-column>
              <el-table-column prop="completedCount" label="完成任务数"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import request from '@/api/index.js'

export default {
  name: 'TaskStats',
  data() {
    return {
      loading: false,
      stats: {
        byType: [],
        bySource: [],
        byCompleter: [],
        summary: { totalTasks: 0, totalCompleted: 0, totalBySource: 0, totalByCompleter: 0 }
      }
    }
  },
  mounted() {
    this.loadStats()
  },
  methods: {
    async loadStats() {
      this.loading = true
      try {
        const res = await request.get('/admin/tasks/stats-summary-all')
        if (res.code === 200) {
          this.stats = res.data
        }
      } catch (e) {
        console.error('加载统计数据失败', e)
        this.$message.error('加载统计数据失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.task-stats { padding: 20px; }
.title { font-size: 18px; font-weight: bold; }
.summary-row { margin-bottom: 20px; }
.stat-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px; padding: 20px; text-align: center; color: white;
}
.stat-card.success { background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); }
.stat-card.warning { background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); }
.stat-card.info { background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); }
.stat-value { font-size: 32px; font-weight: bold; }
.stat-label { font-size: 14px; margin-top: 5px; opacity: 0.9; }
.chart-card { margin-bottom: 20px; }
</style>
